import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ClosedPlanView, ClosedPlanViewDefaultValues, ClosePlanModel, ClosePlanModelDefaultValues } from 'src/app/components/participants/plans/plan';
import { ParticipantThemeService } from 'src/app/services/participant-theme.service';
import { PlanService } from 'src/app/services/plan.service';
import { ToastService } from 'src/app/services/toast-service.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-close-plan',
    templateUrl: './close-plan.component.html',
    styleUrls: ['./close-plan.component.scss'],
    standalone: false
})

export class ClosePlanComponent {
  closedPlanView: ClosedPlanView = ClosedPlanViewDefaultValues();
  closePlanDetails: ClosePlanModel = ClosePlanModelDefaultValues();
  rowNums = 2;
  colNums = 150;
  showYesPanel: boolean = false;
  showNoPanel: boolean = false;
  participantClassByRole: string = '';
  translations: any;
  llttfPage: boolean = false;

  constructor(private _planservice: PlanService,
    private router: Router,
    private route: ActivatedRoute,
    private toastservice: ToastService,
    private translationservice: TranslationService,
    private themeService: ParticipantThemeService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.closedPlanView.id = params['planid'];
      this.closePlanDetails.id = params['planid'];

      this._planservice.viewPlan(this.closedPlanView.id).subscribe({
        next: (data) => {
          this.closedPlanView = data;
        }
      });
    });

    this.themeService.setParticipantTheme();
    this.participantClassByRole = this.themeService.participantClassByRole;
    this.llttfPage = this.themeService.llttfPage;

    this.translationservice.getTranslation().subscribe({
      next: (translation) => {
        this.translations = translation;
      }
    });
  }

  onClosePlanClick() {
    this._planservice.closePlan(this.closePlanDetails).subscribe({
      next: () => {
        this.toastservice.showMessage('Plan closed successfully');
        this.router.navigateByUrl('/dashboard-participant');
      }
    });
  }

}
